import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

// Also attach Authorization header if token present
export function setAuthToken(token) {
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    localStorage.setItem("sos_token", token);
  } else {
    delete api.defaults.headers.common["Authorization"];
    localStorage.removeItem("sos_token");
  }
}

const existing = localStorage.getItem("sos_token");
if (existing) setAuthToken(existing);

export function apiErr(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(", ");
  if (d?.msg) return d.msg;
  return e?.message || "Something went wrong";
}
